import { DatePicker, Select } from 'antd'
import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import apiUrls from '../../../Api/MainApi'
import dayjs from 'dayjs';
import moment from 'moment'
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


function NcbDrawer({ formData, setFormData }) {
    const [insurerData, setInsurerData] = useState([])
    const [ncb, setNcb] = useState([])
    const [policyType, setPolicyType] = useState([])
    const [claims, setClaims] = useState('Yes')
    useEffect(() => {
        const fetchInsurerData = async () => {
            const insurerResponse = await axios.get(apiUrls.GetInsurerMasterDropDown);
            const datas = insurerResponse.data.data;
            setInsurerData(datas);
        }
        const fetchNcbData = async () => {
            const ncbResponse = await axios.get(apiUrls.GetNCB);
            const datas = ncbResponse.data.data;
            setNcb(datas);
        }
        const fetchPolicyType = async () => {

            const policyResponse = await axios.post(apiUrls.GetProductDropDown, { name: 'Car' });
            const datas = policyResponse.data.data;
            setPolicyType(datas);
        }
        fetchPolicyType();
        fetchNcbData();
        fetchInsurerData();
    }, [])

    const handlePolicyChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            policy: selectedOption
        }))
    }
    const handlePreviousPolicyChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            previousPolicy: selectedOption
        }))
    }
    const handleInsurerChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            previousInsurer: selectedOption
        }))
    }
    const handleClaimsChange = (selectedOption) => {
        setClaims(selectedOption)
    }
    const handleDateChange = (date, dateString) => {
        setFormData(prevData => ({
            ...prevData,
            previousPolicyExpiryDate: dateString ? moment(dateString).format('YYYY-MM-DD') : ''
        }));

    };
    const handleNcbChange = (selectedOption) => {
        setFormData(prevData => ({
            ...prevData,
            ncb: selectedOption
        }));
    }
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return (
        <>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Expiry Date</h6>
                    <DatePicker
                        // value={formData.previousPolicyExpiryDate ? moment(formData.previousPolicyExpiryDate, 'YYYY-MM-DD') : null}
                        // className='width-date'
                        defaultValue={(dayjs(formData.previousPolicyExpiryDate, 'YYYY-MM-DD'))}
                        style={{
                            width: '100%',
                        }}
                        onChange={handleDateChange}
                    />
                </div>
            </div>

            {/* /// for manufaturer /////// */}
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Policy Type</h6>
                    <Select
                        name="Make"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.policy}
                        onChange={handlePolicyChange}
                        className="width-specifiying"
                        options={(policyType.length > 0 ? policyType : [{ id: 0, name: "No type Found" }]).map(policyType => ({ key: `policyType-${policyType.id}`, value: policyType.id, label: policyType.name }))}
                        placeholder="Select policy"
                    />
                </div>
            </div>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Previous Policy Type</h6>
                    <Select
                        name="Model"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.previousPolicy}
                        onChange={handlePreviousPolicyChange}
                        className="width-specifiying"
                        options={(policyType.length > 0 ? policyType : [{ id: 0, name: "No type Found" }]).map(policyType => ({ key: `policyType-${policyType.id}`, value: policyType.id, label: policyType.name }))}
                        placeholder="Select previous policy"
                    />
                </div>
            </div>
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Previous Insurer</h6>
                    <Select
                        name="Variant"
                        style={{
                            width: '100%',
                        }}
                        showSearch
                        filterOption={filterOption}
                        value={formData.previousInsurer}
                        onChange={handleInsurerChange}
                        className="width-specifiying"
                        options={(insurerData.length > 0 ? insurerData : [{ id: 0, name: "No Insurer Found" }]).map(make => ({ key: `make-${make.id}`, value: make.id, label: make.name }))}
                        placeholder="Select Variant"
                    />
                </div>
            </div>

            {/* ///// for variant //// */}
            <div className='wrapper-div-rto'>
                <div className='container'>
                    <h6 className='select-label-title'>Made any claims</h6>
                    <Select
                        name="Previous claims"
                        showSearch
                        style={{
                            width: '100%',
                        }}
                        filterOption={filterOption}
                        value={formData.previousClaims}
                        onChange={handleClaimsChange}
                        className="width-specifiying"
                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                        placeholder="Previous Claims"
                    />
                </div>
            </div>
            {
                formData.previousClaims === 'No' && (
                    <div className='wrapper-div-rto'>
                        <div className='container'>
                            <h6 className='select-label-title'>Select NCb % </h6>
                            <Select
                                name="Previous insurer"
                                showSearch
                                style={{
                                    width: '100%',
                                }}
                                filterOption={filterOption}
                                value={formData.ncb}
                                onChange={handleNcbChange}
                                className="width-specifiying"
                                options={(ncb.length > 0 ? ncb : [{ id: 0, name: "No NCB Found" }]).map(ncb => ({ key: `ncb-${ncb.id}`, value: ncb.id, label: ncb.name }))}
                                placeholder="Select Ncb Insurer"
                            />
                        </div>
                    </div>
                )
            }


        </>
    )
}

export default NcbDrawer